import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FiBookOpen, FiTrendingUp, FiPlayCircle, FiClock } from 'react-icons/fi';
import api, { RUTA_ARCHIVOS } from '../api/client';
import { useAuth } from '../context/AuthContext';
import Estrellas from '../components/Estrellas';

function CardCurso({ curso }) {
    return (
        <Link to={`/curso/${curso.id}`} className="curso-card" style={{ textDecoration: 'none', color: 'inherit' }}>
            <div className="curso-cover">
                {curso.imagen_portada ? (
                    <img src={curso.imagen_portada.startsWith('http') ? curso.imagen_portada : `${RUTA_ARCHIVOS}${curso.imagen_portada}`} alt={curso.nombre} />
                ) : (
                    <FiBookOpen />
                )}
                {curso.nivel && <span className="badge">{curso.nivel}</span>}
            </div>
            <div className="curso-body">
                <h3 className="curso-titulo">{curso.nombre}</h3>
                <p className="curso-prof">{curso.profesor_nombre || 'Sin profesor'}</p>
                <div className="curso-meta">
                    <span className="star"><Estrellas valor={Math.round(curso.calificacion_promedio || 0)} soloLectura tamano={14} /></span>
                    <span><FiPlayCircle size={12} /> {curso.total_videos || 0} clases</span>
                    <span><FiClock size={12} /> {curso.duracion_horas || 0}h</span>
                </div>
                {curso.progreso_porcentaje !== undefined && (
                    <div className="barra-progreso" style={{ marginTop: 12 }}>
                        <div className="barra-progreso-fill" style={{ width: `${curso.progreso_porcentaje}%` }} />
                    </div>
                )}
            </div>
        </Link>
    );
}

export default function Inicio() {
    const { usuario } = useAuth();
    const [cursos, setCursos] = useState([]);
    const [misCursos, setMisCursos] = useState([]);
    const [cargando, setCargando] = useState(true);

    useEffect(() => {
        Promise.all([
            api.get('/cursos'),
            api.get('/cursos/mis-cursos').catch(() => ({ data: { cursos: [] } }))
        ]).then(([all, mine]) => {
            setCursos(all.data.cursos || []);
            setMisCursos(mine.data.cursos || []);
        }).finally(() => setCargando(false));
    }, []);

    if (cargando) return <div className="loader"><div className="spinner" /><span>Cargando...</span></div>;

    const enProgreso = misCursos.filter(c => !c.completado);
    const completados = misCursos.filter(c => c.completado);

    return (
        <div>
            <div style={{ marginBottom: 28 }}>
                <h1 style={{ margin: '0 0 6px', fontSize: 26 }}>
                    Hola, {usuario?.nombre} {usuario?.apellido_paterno}
                </h1>
                <p style={{ color: 'var(--texto-suave)', margin: 0 }}>
                    Continua aprendiendo donde lo dejaste
                </p>
            </div>

            <div className="stats-grid">
                <div className="stat-card">
                    <div className="label">Cursos Inscritos</div>
                    <div className="valor">{misCursos.length}</div>
                </div>
                <div className="stat-card">
                    <div className="label">En Progreso</div>
                    <div className="valor">{enProgreso.length}</div>
                </div>
                <div className="stat-card">
                    <div className="label">Completados</div>
                    <div className="valor">{completados.length}</div>
                </div>
                <div className="stat-card">
                    <div className="label">Cursos Disponibles</div>
                    <div className="valor">{cursos.length}</div>
                </div>
            </div>

            {enProgreso.length > 0 && (
                <div style={{ marginBottom: 32 }}>
                    <h2 style={{ fontSize: 18, marginBottom: 14, display: 'flex', alignItems: 'center', gap: 8 }}>
                        <FiTrendingUp /> Continua Aprendiendo
                    </h2>
                    <div className="cursos-grid">
                        {enProgreso.map(c => <CardCurso key={c.id} curso={c} />)}
                    </div>
                </div>
            )}

            <div>
                <h2 style={{ fontSize: 18, marginBottom: 14, display: 'flex', alignItems: 'center', gap: 8 }}>
                    <FiBookOpen /> Cursos Disponibles
                </h2>
                {cursos.length === 0 ? (
                    <div className="card" style={{ textAlign: 'center', padding: 40, color: 'var(--texto-suave)' }}>
                        Aun no hay cursos disponibles
                    </div>
                ) : (
                    <div className="cursos-grid">
                        {cursos.map(c => <CardCurso key={c.id} curso={c} />)}
                    </div>
                )}
            </div>
        </div>
    );
}
